import styled from '@emotion/styled';
import { Box, Flex } from '@lightspeed/flame/Core';
import { Text } from '@lightspeed/flame/Text';

export const RegisterTitleWrapper = styled.div`
  margin-top: 16px;
  margin-bottom: 2px;
  display: flex;
  justify-content: center;
`;
export const WorkOrderTitleWrapper = styled.div`
  margin-top: 2px;
  margin-bottom: 10px;
  display: flex;
  justify-content: center;
`;

export const TotalsRow = styled(Flex)`
  justify-content: space-between;
  padding: 4px 15px;
`;

export const RegisterTitleText = styled(Text)`
  color: #181a1a;
  font-size: 0.75rem;
  font-weight: bolder;
  text-transform: uppercase;
  letter-spacing: 0.0625rem;
  padding: 0 6px;
  background: #fff;
  font-family: Lato, Helvetica Neue, Helvetica, Arial, sans-serif;
  display: flex;
  gap: 4px;
`;

export const WorkOrderTitleText = styled(Text)`
  font-size: 12px;
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  font-family: Lato, Helvetica Neue, Helvetica, Arial, sans-serif;
  display: flex;
  gap: 4px;
`;

export const TotalRowText = styled(Text)`
  color: #848a8a;
  font-weight: 400;
  display: flex;
  gap: 4px;
`;

export const PaymentRequestListingLinkContainer = styled(Box)`
  display: flex;
  align-items: center;
  gap: 10px;
  background-color: #ebebeb;
  padding: 12px;
`;
